import States from '../helpers/states';
import ScrollListener from '../helpers/scroll-listener';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import Component from '../components/component';
import VideosPopinManager from '../helpers/videos-popin-manager';
import MenuDesktop from '../components/menu/menu.desktop';
import MenuMobile from '../components/menu/menu.mobile';
import Flickity from 'flickity';


export const PageEvent = {
    NEXT: '__pe_next',
    PAGE_DESTROYED: '__pe_page_destroyed',
    ADD_SCENE: '__pe_page_add_scene',
    FLICKITY_CLICK: '__pe_page_flickity_click'
};

export default class Page extends Component {
    constructor(page, components) {
        super();

        this.dom = {
            component: page,
            page,
            container: this._find('.container'),
            scrollSections: this._findAll('.scroll-section')
        };

        this.Components = components;
        this.VideosPopinManager = new VideosPopinManager();

        bindAll(this, [
            '_update',
            '_next',
            '_destroy'
        ]);

        this._showTl = new TimelineMax({ paused: true });
        this._hideTl = new TimelineMax({
            paused: true,
            onStart: () => {
                this.dom.page.style.position = 'absolute';
                this.dom.page.style.top = -getWindowPosition() + 'px';

                // Reset scroll
                document.scrollingElement.scrollTop = document.scrollingElement.scrollLeft =
                document.body.scrollTop = document.body.scrollLeft =
                document.documentElement.scrollTop = document.documentElement.scrollLeft =
                window.scrollTop = window.scrollLeft = 0;
            },
            onComplete: this._destroy
        });

        this._initScrollMagic();

        this._initTls();

        this._initFlktyEvent();
    }

    _initFlktyEvent(){

        // TRY TO FIX FLICKITY BUG ON IOS 13
        var touchingCarousel = false,
            touchStartCoords;
        document.body.addEventListener('touchstart', function(e) {
            if ( closest(e.target, '.flickity-slider') ) {
                touchingCarousel = true;
            } else {
                touchingCarousel = false;
                return;
            }

            touchStartCoords = {
                x: e.touches[0].pageX,
                y: e.touches[0].pageY
            }
        });
        document.body.addEventListener('touchmove', function(e) {
            if (!(touchingCarousel && e.cancelable)) {
                return;
            }
            var moveVector = {
                x: e.touches[0].pageX - touchStartCoords.x,
                y: e.touches[0].pageY - touchStartCoords.y
            };
            if (Math.abs(moveVector.x) > 7)
                e.preventDefault()
        }, {passive: false});

        
        // Bind Global Flickity Events
        for(var componentName in this.Components){
            var component = this.Components[componentName];

            if( component.length > 0 ) {
                for( let i = 0, j = component.length; i < j; i++) {
                    let componentTab = component[i];
                    if(componentTab instanceof Flickity){
                    }
                }
            } else {
                for( let key in component ) {
                    let componentTab = component[key];
                    if(componentTab instanceof Flickity){
                        component.on(PageEvent.FLICKITY_CLICK, target => { // WILL BUG IF MORE THAN ONE FLICKITY
                            let videoPopinManager = this.VideosPopinManager;
                            let AllVideos = videoPopinManager.AllVideos;
                            let currentId = target.getAttribute('data-video'); // changed from data-id to data-video in VideoPopinManager
                            let theVideo = AllVideos.filter(item => item.id === currentId);


                            if(theVideo.length == 0){
                                console.warn('video not found', )
                                return;
                            }
                            theVideo = theVideo[0];
                            let theVideoInstance = theVideo.instance;
                            videoPopinManager.showPopin(undefined, true/** hasBeenEmitted */)
                            theVideoInstance._loadVideo(undefined, true/** hasBeenEmitted */);
                        })
                    }
                }
            }
        }
    }

    _retrieveDOM() {
    }

    _initTls() {

        this._showTl
            .from(this.dom.page, 0.8, { autoAlpha: 0 }, 0)

        this._hideTl
            .to(this.dom.page, 0.5, { autoAlpha: 0 }, 0)
            .add(() => {
                this._next();
            }, 0)
    }

    init() {
        this._ScrollListener = new ScrollListener( this._update );
    }

    bind() {
        this.VideosPopinManager._bind();
    }

    _initScrollMagic() {

        this._scrollMagicController = new ScrollMagic.Controller( {
            globalSceneOptions: {reverse: true}
        } );
        this._scrollMagicScenes = [];

        for( var componentName in this.Components )
        {
            var component = this.Components[componentName];

            // Bind Global Add Scroll Magic Scene
            if( component.length > 0 ) {
                for( let i = 0, j = component.length; i < j; i++) {
                    let componentTab = component[i];
                    componentTab.on( PageEvent.ADD_SCENE, (scene) => {
                        scene.addTo(this._scrollMagicController);
                        this._scrollMagicScenes.push( scene );
                    } );
                }
            } else {
                component.on( PageEvent.ADD_SCENE, (scene) => {
                    scene.addTo(this._scrollMagicController);
                    this._scrollMagicScenes.push( scene );
                } );
            }
        }
    }

    _update( top ) {
        for ( var componentName in this.Components ) {
            var component = this.Components[componentName];
            if( component.length > 0 ) {
                for( let i = 0, j = component.length; i < j; i++) {
                    let componentTab = component[i];
                    if( componentTab.hasOwnProperty('animated') && componentTab.hasOwnProperty('animated') == true )
                        componentTab._update( top );
                }
            } else {
                if( component.hasOwnProperty('animated') && component.hasOwnProperty('animated') == true )
                    component._update( top );
            }
        }
    }

    unbind() {
        this.VideosPopinManager._unbind();
    }

    show() {
        this._showTl.play();
    }

    hide() {
        this._showTl.kill();
        this._hideTl.play();
    }

    resize(width = States.width, height = States.height) {
    }

    _next() {
        this.emit(PageEvent.NEXT);
    }

    _destroy() {
        this._next();
        this.emit(PageEvent.PAGE_DESTROYED);
    }

    _getPersitance() {
        return false;
    }

    getScroll() {
        return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
    }
}



// WEBPACK FOOTER //
// src/js/pages/page.js